/* eslint-disable prettier/prettier */
export const GET_IS_FETCHING_APPROVERS = "GET_IS_FETCHING_APPROVERS";
export const GET_IS_FETCHING_VERIFIERS = "GET_IS_FETCHING_VERIFIERS";
export const GET_IS_FETCHING_USER_SETTINGS = "GET_IS_FETCHING_USER_SETTINGS";
export const GET_USER_SETTINGS = "GET_USER_SETTINGS";
export const GET_IS_ADDING_USER = "GET_IS_ADDING_USER";
export const GET_IS_EDITING_USER_DETAILS = "GET_IS_EDITING_USER_DETAILS";
export const GET_IS_FETCHING_USER_ROLES = "GET_IS_FETCHING_USER_ROLES";
export const GET_USER_CONTRACT_TYPES = "GET_USER_CONTRACT_TYPES";
export const GET_USER_WORKING_HOURS = "GET_USER_WORKING_HOURS";
export const GET_IS_FETCHING_USER_CONTRACT_TYPES = "GET_IS_FETCHING_USER_CONTRACT_TYPES";
export const GET_IS_FETCHING_USER_WORKING_HOURS = "GET_IS_FETCHING_USER_WORKING_HOURS";
export const GET_IS_FETCHING_USER_EXPERIENCE_FUNCTIONS = "GET_IS_FETCHING_USER_EXPERIENCE_FUNCTIONS";
export const GET_USER_EXPERIENCE_FUNCTIONS = "GET_USER_EXPERIENCE_FUNCTIONS";
export const GET_IS_FETCHING_USER_LOCATION_GROUPINGS = "GET_IS_FETCHING_USER_LOCATION_GROUPINGS";
export const GET_USER_LOCATION_GROUPINGS = "GET_USER_LOCATION_GROUPINGS";
export const GET_BOOKING_MANAGERS = "GET_BOOKING_MANAGERS";
export const GET_IS_FETCHING_MANAGERS = "GET_IS_FETCHING_MANAGERS";
export const GET_USERS = "GET_USERS";
export const GET_IS_FETCHING_USERS = "GET_IS_FETCHING_USERS";

const usersGetters = {
  [GET_BOOKING_MANAGERS]: state => state.bookingManagers,
  [GET_IS_FETCHING_MANAGERS]: state => state.isFetchingBookingManagers,
  [GET_IS_FETCHING_APPROVERS]: state => state.isFetchingApprovers,
  [GET_IS_FETCHING_VERIFIERS]: state => state.isFetchingVerifiers,
  [GET_IS_FETCHING_USER_SETTINGS]: state => state.isFetchingUserSettings,
  [GET_USER_SETTINGS]: state => state.userSettings,
  [GET_IS_ADDING_USER]: state => state.isAddingUser,
  [GET_IS_EDITING_USER_DETAILS]: state => state.isEditingUserDetails,
  [GET_IS_FETCHING_USER_ROLES]: state => state.isFetchingUserRoles,
  [GET_IS_FETCHING_USER_CONTRACT_TYPES]: state => state.isFetchingUserContractTypes,
  [GET_IS_FETCHING_USER_WORKING_HOURS]: state => state.isFetchingUserWorkingHours,
  [GET_IS_FETCHING_USER_EXPERIENCE_FUNCTIONS]: state => state.isFetchingUserExperienceFunctions,
  [GET_USER_EXPERIENCE_FUNCTIONS]: state => state.userExperienceFunctions,
  [GET_USER_LOCATION_GROUPINGS]: state => state.userLocationGroupings,
  [GET_IS_FETCHING_USER_LOCATION_GROUPINGS]: state => state.isFetchingUserLocationGroupings,
  [GET_IS_FETCHING_USERS]: state => state.isFetchingUsers,
  [GET_USERS]: state => state.users,
  [GET_USER_CONTRACT_TYPES]: state => state.userContractTypes,
  [GET_USER_WORKING_HOURS]: state => state.userWorkingHours,
};

export default usersGetters;
